<template>

    <div>

        <!-- show loading indicator -->
        <loading-indicator :loading="isLoading"></loading-indicator>

        <template v-if="!isLoading">


            <div class="box">

                <div class="is-clearfix" v-if="!isEmbeddedView">

                    <div class="is-pulled-right">

                        <div class="columns filters">

                            <div class="column" v-if="articleVariantTypes.length > 0">
                                <form-input inputType="select" label="COMPLAT-CALENDAR-FILTER-TYPES" minWidth="200px" :showLabelInOptions="true" :showLabel="false" :selectOptions="articleVariantTypes" v-model="filterArticleVariant"></form-input>
                            </div>

                            <!--
                            <div class="column">
                                <form-input inputType="select" label="COMPLAT-CALENDAR-FILTER-STATUS" minWidth="200px" :showLabelInOptions="true" :showLabel="false" :selectOptions="articleVariantStatus" v-model="filterArticleStatus"></form-input>
                            </div>
                            -->

                            <div class="column" v-if="articleTopics.length > 0">
                                <form-input inputType="select" label="COMPLAT-CALENDAR-FILTER-TOPICS" minWidth="220px" :showLabelInOptions="false" :showLabel="false" :selectOptions="articleTopics" v-model="filterArticleTopic"></form-input>
                            </div>

                            <div class="column" v-if="articleCategories.length > 0">
                                <form-input inputType="select" label="COMPLAT-CALENDAR-FILTER-CATEGORIES" :showLabelInOptions="false" :showLabel="false" :selectOptions="articleCategories" v-model="filterArticleCategory"></form-input>
                            </div>

                            <div class="column" v-if="articleTopics.length > 0 || articleCategories.length > 0 || articleVariantTypes.length > 0">
                                <span :class="[isFilterActive ? 'is-blue' : 'is-disabled', 'button reset-filter']" @click="resetFilters" :title="isFilterActive ? 'Klick um Filter zurückzusetzen' : ''">
                                    <span class="icon is-small"><i class="icon-ak-reset" aria-hidden="true"></i></span>
                                </span>
                            </div>

                        </div>
                    </div>

                </div>


                <div :class="['calendar', { 'embeddedView': isEmbeddedView}]">

                    <ul class="calendarHeader">

                        <!-- NAVIGATION -->
                        <li class="navigation">

                            <span class="icon is-large prev" @click="nav(false)">
                                <i class="fa fa-angle-left" aria-hidden="true"></i>
                            </span>

                            <span class="title"><template v-if="calendarView=='month'">{{ months[this.currentMonth] }}, </template>{{ currentYear }}</span>

                            <span class="icon is-large next" @click="nav(true)">
                                <i class="fa fa-angle-right" aria-hidden="true"></i>
                            </span>

                        </li>

                        <!-- CALENDAR VIEW SWITCHER -->
                        <li class="switchCalendarType is-pulled-right">

                            <button :class="[ { 'is-active': calendarView=='month' }, 'button is-small is-light']" @click="changeCalendarView('month')">
                                <span class="icon is-small">
                                    <i class="fa fa-th" aria-hidden="true"></i>
                                </span>
                                Monat
                            </button>

                            <button :class="[ { 'is-active' : calendarView=='year' }, 'button is-small is-light']" @click="changeCalendarView('year')">
                                <span class="icon is-small">
                                    <i class="fa fa-th-large" aria-hidden="true"></i>
                                </span>
                                Jahr
                            </button>

                        </li>

                    </ul>


                    <div class="calendarBody">

                        <!-- DEFAULT EVENTS -->
            			<div class="rows">

            				<div class="row" v-for="(article, index) in articles" :key="article.id">

            					<div class="label has-pointer" @click="goToArticle(article)">
                                    <template v-if="!isEmbeddedView">
                                        <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="getImage(article.image)"></div>
                                        <span class="title">{{ article.title }}</span>
                                    </template>
                                    <template v-else>
                                        <span class="title">{{ article.title }}</span>
                                    </template>
            					</div>

            					<div class="events">

                                    <template v-for="variant in article.variants">

                                        <template v-for="publication in variant.publications">

                                            <!-- <transition name="fade" appear> -->

                                                <popover width="340" trigger="hover">

                                                    <div class="event" :style="getEventPosition(publication, variant.type)" :key="publication.id">
                                                        <span :class="['icon is-small', { 'isReady': publication.isReady }]" @click="goToVariant(variant, article.id)"><i :class="channelIcon[variant.type]"></i></span>
                                                    </div>

                                                    <div slot="content" class="calendarPopover">

                                                        <div class="block">
                                                            <span class="channel">{{ $t('COMPLAT-CALENDAR-CHANNEL-'+variant.type )}}</span>
                                                            <span class="title">{{ variant.headline }}</span>
                                                        </div>

                                                        <div class="block noLine">
                                                            <span class="newsletterChannel" v-if="variant.type=='NEWSLETTER'"><span>Kanal:</span> {{ publication && publication.type ? publication.type.slice(11) : '' }}</span>
                                                            <div class="date" v-if="variant.publications.length > 0"><span>Veröffentlichung:</span> {{ formatDate2(publication.publishDate, false)}}</div>
                                                            <div class="status"><span>Status:</span> {{ $t('COMPLAT-CALENDAR-VARIANT-STATUS-'+variant.status) }}</div>
                                                        </div>

                                                    </div>

                                                </popover>

                                            <!-- </transition> -->

                                        </template> <!-- // loop variant.publications -->

            						</template> <!-- // loop article.variants -->

            					</div> <!-- // .events -->

            				</div>




                            <!-- TOPIC EVENTS -->
                            <div class="rows specialEvents" v-for="(channels, key, index) in commonEvents.TOPIC" :key="key">

                				<div class="row category">

                					<div class="label">
                						<lang :labelKey="'MARKETING_CHANNEL_CATEGORY-'+key"></lang>
                					</div>

                					<div class="events"></div>

                				</div>

                				<div v-for="(channel, key, index) in channels" :key="key" class="row">

                					<div class="label">
                						{{ key }}
                					</div>

                					<div class="events">

                						<template v-for="event in channel">

                							<transition name="fade" appear>

                								<popover width="340" trigger="hover">

                									<div class="event" :style="getEventPosition(event, 'commonEvent')">
                										<span class="eventTitle">{{ event.title }}</span>
                									</div>

                									<div slot="content" class="calendarPopover">

                										<div class="block is-clearfix">

                                                            <span class="date">
                                                                <template v-if="event.startDate.split('T')[0] == event.endDate.split('T')[0]">
                    												{{ formatDate2(event.startDate, false) }}
                    											</template>

                    											<template v-else>
                    												{{ formatDate2(event.startDate, false) }} - {{ formatDate2(event.endDate, false) }}
                    											</template>
                                                            </span>

                											<!-- <span class="date">{{ formatDate2(event.startDate, false) }} - {{ formatDate2(event.endDate, false) }}</span> -->
                										</div>

                										<div class="block is-clearfix">
                											<span class="channel" v-if="event.marketingChannel != null">{{ $t('TERM_MARKETING_CHANNELS-'+event.marketingChannel.name) }}</span>
                											<span class="title">{{ event.title }}</span>
                										</div>

                									</div>

                								</popover>

                							</transition>

                						</template>


                					</div>

                				</div>
                			</div>


                            <!-- HOLIDAY EVENTS -->
                			<!-- <div class="rows specialEvents" v-for="(channels, key, index) in holidays" :key="key" v-if="!Array.isArray(commonEvents.SPECIAL_DATE.SPECIAL_DATE)"> -->
                            <div class="rows specialEvents" v-for="(channels, key, index) in commonEvents.SPECIAL_DATE" :key="key">

                				<div class="row category">

                					<div class="label has-pointer" @click="eventAdd(key)" title="hinzufügen">
                						<lang :labelKey="'MARKETING_CHANNEL_CATEGORY-'+key"></lang>
                                        <span class="icon is-small"><i class="icon-ak-hinzufuegen"></i></span>
                					</div>

                					<div class="events"></div>

                				</div>

                				<div v-for="(channel, key, index) in channels" :key="key" class="row">

                					<div class="label">
                						<lang :labelKey="'TERM_MARKETING_CHANNELS-'+key"></lang>
                                    </div>

                					<div class="events">

                						<template v-for="event in channel">

                							<transition name="fade" appear>

                								<popover width="340" trigger="hover">

                									<div class="event" :style="getEventPosition(event, 'commonEvent')">
                										<span class="eventTitle">{{ event.title }}</span>
                									</div>

                									<div slot="content" class="calendarPopover">

                										<div class="block is-clearfix">

                                                            <span class="date">
                                                                <template v-if="event.startDate.split('T')[0] == event.endDate.split('T')[0]">
                    												{{ formatDate2(event.startDate, false) }}
                    											</template>

                    											<template v-else>
                    												{{ formatDate2(event.startDate, false) }} - {{ formatDate2(event.endDate, false) }}
                    											</template>
                                                            </span>

                                                            <div class="edit is-pulled-right">
                												<span class="icon is-small has-pointer" @click="eventEdit(event)" title="bearbeiten"><i class="icon-ak-bearbeiten"></i></span>
                												<span class="icon is-small has-pointer" @click="eventDelete(event)" title="entfernen"><i class="icon-ak-entfernen"></i></span>
                											</div>
                											<!-- <span class="date">{{ formatDate2(event.startDate, false) }} - {{ formatDate2(event.endDate, false) }}</span> -->
                										</div>

                										<div class="block is-clearfix">
                											<span class="channel" v-if="event.marketingChannel != null">{{ $t('TERM_MARKETING_CHANNELS-'+event.marketingChannel.name) }}</span>
                											<span class="title">{{ event.title }}</span>
                										</div>

                									</div>

                								</popover>

                							</transition>

                						</template>


                					</div>

                				</div>

                			</div>


            			</div> <!-- // rows -->


                        <!-- COLS -->
                        <div :class="['cols', calendarView]">

                            <!-- MONTH View -->
                            <template v-if="calendarView == 'month'">

                                <div v-for="n in currentDaysPerMonth" class="col day">
                                    <div class="head">{{ n }}</div>
                                    <div :class="[ { isWeekend: isDateHoliday(currentYear, currentMonth, n) }, 'body']"></div>
                                </div>

                            </template>

                            <!-- YEAR View -->
                            <template v-else>

                                <div class="col" v-for="n in 12" :style="calculateColWidth(n)">
                                    <div class="head has-pointer" @click="goToMonth(n)" :title="'Klick um zu Monat ' + months[n-1] + ' zu springen'">{{ monthsShort[n-1] }}</div>
                                    <div class="body"></div>
                                </div>

                            </template>

                        </div>

                        <template v-if="currentYear == date.getFullYear()">

                            <template v-if="calendarView == 'month' && currentMonth == date.getMonth()">
                                <div :style="getMarkerPosition('month')" class="currentDayMarker"></div>
                            </template>
                            <template v-else-if="calendarView == 'year'">
                                <div :style="getMarkerPosition('year')" class="currentDayMarker"></div>
                            </template>

                        </template>

                    </div> <!-- // calendar body -->

                </div> <!-- // calendar -->

            </div> <!-- // box -->


        </template>






    <modal
			:title="modal.title"
			:is-show="showModal"
			:backdrop-closable="false"
			transition="fadeDown"
			@close="closeModal()"
			class="vcenter"
			ok-text="speichern"
			cancel-text="abbrechen"
			:on-ok="eventSave"
			width="540">

				<div style="margin: 0 auto; width: 450px">

					<form-input inputType="select" label="CALENDAR-EVENT-TYP" minWidth="200px" :showLabelInOptions="true" :showLabel="true" :selectOptions="selectTypes" v-model="activeEvent.type" :isHorizontal="false"></form-input>
					<form-input inputType="text" label="CALENDAR-EVENT-TITLE" minWidth="200px" :showLabelInOptions="true" :showLabel="true" v-model="activeEvent.title" :isHorizontal="false"></form-input>

	                <div class="control is-grouped" :key="activeEvent">

						<div class="control">
							<div class="control-label"><label-name labelKey="CALENDAR-EVENT-STARTDATE"></label-name></div>
							<div class="control">
								<flat-pickr placeholder="Startdatum" :config="datePickerStartOptions" v-model="activeEvent.startDate"></flat-pickr>
								<!-- <datepicker placeholder="Startdatum" :options="datePickerStartOptions" v-model="activeEvent.startDate" ref="datePickerStart"></datepicker> -->
							</div>
						</div>

						<!-- <form-input inputType="datepicker" v-model="activeEvent.startDate"></form-input> -->

						<div class="control">
							<div class="control-label"><label-name labelKey="CALENDAR-EVENT-ENDDATE"></label-name></div>
							<div class="control">
								<flat-pickr placeholder="Enddatum" :config="datePickerEndOptions" v-model="activeEvent.endDate" ref="datePickerEnd"></flat-pickr>
								<!-- <datepicker placeholder="Enddatum" class="form-control" :options="datePickerEndOptions" v-model="activeEvent.endDate" ref="datePickerEnd"></datepicker> -->
							</div>
						</div>

          </div>

				</div>

    			<template slot="footer">
    				<span class="button" @click="closeModal(true)">abbrechen</span>
    				<span class="button is-primary" @click="eventSave">speichern</span>
    			</template>

        </modal>





    </div>


</template>


<script>
import flatPickr from 'vue-flatpickr-component';
import { de } from 'flatpickr/dist/l10n/de.js';
de.firstDayOfWeek = 1; // Monday


export default {

    name: 'contentPoolCalendar',

    components: {
        flatPickr
    },

    props: {
        articleId: {
            type: Number,
            default: null
        },
    },

    data() {

		var self = this;

        return {

            isLoading: false,

            filterArticleVariant: null,
			filterArticleCategory: null,
            filterArticleTopic: null,
			// filterArticleStatus: null,

            articleVariantTypes: [],
            articleTopics: [],
            articleCategories: [],

            calendarView: 'month',
            date: new Date(),
            currentDate: new Date(),
            currentMonth: '',
            currentYear: '',

            currentColWidth: 0,
			currentColsWidth: 0,

            months: ['Jänner', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
            monthsShort: ['JAN', 'FEB', 'MÄR', 'APR', 'MAI', 'JUN', 'JUL', 'AUG', 'SEP', 'OKT', 'NOV', 'DEZ'],
            channelIcon: {
                HERBA_IMPULSE_PRINT: 'fa icon-ak-ch-print',
                HERBA_IMPULSE_ONLINE: 'fa icon-ak-ch-internet',
                NEWSLETTER: 'fa icon-ak-ch-email',
                FACEBOOK: 'fa icon-ak-ch-socialmedia',
                INTRANET: 'fa icon-ak-ch-intranet',
                TEASER_INTERNAL: 'fa icon-ak-ch-teaser-intern',
                COOPERATE: 'fa icon-ak-ch-cooperate'
            },

            isEmbeddedView: false,

            showPublications: false,
            showData: false,

            commonEvents: {},

            activeEvent: {},

            showModal: false,
			modal: {
				type: '',
				isSaving: false,
				isLoading: false,
                title: ''
			},
      datePickerStartOptions: {
        wrap: false,
        enableTime: false,
        altInput: true,
        altFormat: 'd.m.Y',
        locale: de,
				clickOpens: true,
        weekNumbers: true,
				minDate: null,
				maxDate: null,
				onOpen(selectedDates, dateStr, instance) {
					self.$set(self.datePickerEndOptions, 'minDate', dateStr);
        },
        onClose(selectedDates, dateStr, instance) {
					self.$set(self.datePickerEndOptions, 'minDate', dateStr);
        }
      },

			datePickerEndOptions: {
        enableTime: false,
        altInput: true,
        altFormat: 'd.m.Y',
        locale: de,
				clickOpens: true,
        weekNumbers: true,
				minDate: null,
				maxDate: null,
				onStartChange(selectedDates, dateStr, instance) {
	         self.$set(self.datePickerStartOptions, 'maxDate', dateStr);
	        },
	        onEndChange(selectedDates, dateStr, instance) {
	          self.$set(self.datePickerStartOptions, 'maxDate', dateStr);
			  	}
        },
      }

  },

	computed: {

		calendarEntryTypes() {
			return this.$store.getters.getTermsByTaxonomy('CALENDAR_ENTRY_TYPES');
		},


        selectTypes() {

            var arr = [];

            for(var type in this.calendarEntryTypes) {
                if(type == 'DEFAULT') {
                    continue;
                }
                arr.push(this.calendarEntryTypes[type])
            }

            return arr;

        },


        currentDaysPerMonth() {
            return this.daysInMonth(this.currentMonth, this.currentYear);
        },

        getEasterDate() {

            var y = this.currentYear;

            var date, a, b, c, m, d;

            // Instantiate the date object.
            date = new Date;

            // Set the timestamp to midnight.
            date.setHours( 0, 0, 0, 0 );

            // Set the year.
            date.setFullYear( y );

            // Find the golden number.
            a = y % 19;

            // Choose which version of the algorithm to use based on the given year.
            b = ( 2200 <= y && y <= 2299 ) ?
                ( ( 11 * a ) + 4 ) % 30 :
                ( ( 11 * a ) + 5 ) % 30;

            // Determine whether or not to compensate for the previous step.
            c = ( ( b === 0 ) || ( b === 1 && a > 10 ) ) ?
                ( b + 1 ) :
                b;

            // Use c first to find the month: April or March.
            m = ( 1 <= c && c <= 19 ) ? 3 : 2;

            // Then use c to find the full moon after the northward equinox.
            d = ( 50 - c ) % 31;

            // Mark the date of that full moon—the "Paschal" full moon.
            date.setMonth( m, d );

            // Count forward the number of days until the following Sunday (Easter).
            date.setMonth( m, d + ( 7 - date.getDay() ) );

            // Gregorian Western Easter Sunday
            return date;

        },

        currentDaysPerYear() {
			return new Date(this.currentYear,1,29).getDate() == 29 ? 366 : 365;
		},

		isFilterActive() {
			return this.filterArticleTopic != null || this.filterArticleCategory != null || this.filterArticleVariant != null;
		},

        articles: {

            cache: false,
            get() {

                var res = [];
                var self = this;

                for(var i=0; i < this.resData.length; i++) {

                    var article = this.resData[i];

                    // filter topics
                    if(this.filterArticleTopic != null) {

                        if(article.topics.length == 0 || !article.topics.some(topic => topic.id == self.filterArticleTopic.id)) {
                            continue;
                        }
                    }

                    // filter categories
                    if(this.filterArticleCategory != null) {

                        if(article.categories.length == 0 || !article.categories.some(cat => cat.id == self.filterArticleCategory.id)) {
                            continue;
                        }
                    }


                    if(article.variants.length == 0) {
                        continue;
                    }

                    var found = false;
                    found = article.variants.some(variant => {

                        // if the filterArticleVariant filter is active ...
                        if(this.filterArticleVariant != null && variant.type != this.filterArticleVariant.name) {
                            return false;
                        }

                        return variant.publications.some(variantPublication => {

                            if(variantPublication.publishDate != null && variantPublication.publishDate.substr(0,4) == this.currentYear) {

                                if(self.calendarView=='month') {

                                    if(parseInt(variantPublication.publishDate.substr(5,2), 10) == (this.currentMonth+1)) {
                                        return true;
                                    }

                                } else {

                                    return true;

                                }

                            }
                        });
                    })

                    if(found) {
                        res.push(article);
                    }

                }

                return res;

            }

        },


	},

    updated() {

        /*
        this.currentColsWidth = $('.cols').width();	// get the width of the .cols container

		if(this.calendarView == 'month') {
			this.currentColWidth = $('.cols > .col').width();	// get the width of the .cols > .col containers
		}
        */

    },

	beforeDestroy() {

		// window.removeEventListener('resize', this.getColWidth());

	},

    created() {

        this.currentMonth = this.currentDate.getMonth();
        this.currentYear = this.currentDate.getFullYear();

        if(this.articleId != null) {
            this.isEmbeddedView = true;
            this.calendarView = 'year';
        }

        this.fetchData();

    },


    mounted() {

        var self = this;

        this.$nextTick(function() {
            window.addEventListener('resize', function() {
				self.currentColsWidth = $('.cols').width();
				if(self.calendarView == 'month') {
					self.currentColWidth = $('.cols > .col').width();
				}
            });
        });

	},

    updated() {

		this.currentColsWidth = $('.cols').width();	// get the width of the .cols container

		if(this.calendarView == 'month') {
			this.currentColWidth = $('.cols > .col').width();	// get the width of the .cols > .col containers
		}

    },

    methods: {

        closeModal(revert=false) {

            if(revert) {


            }

            this.activeEvent = {};
			this.showModal=false;

		},

        eventAdd(key) {

			var self = this;

			this.activeEvent = {
				startDate: null,
				endDate: null,
				title: '',
				description: '',
				site: null,
                type: null,
                communicationPlatform: true,
                showInCommunicationPlatform: true,
				marketingChannel: null,
				tasks: [],
			}

			this.modal.type = 'eventAdd';
			this.modal.title = 'Neuen Beitrag anlegen';
			this.showModal = true;

        },

        eventEdit(event) {

            this.activeEvent = event;


			this.modal.type = 'eventAdd';
			this.modal.title = 'Beitrag bearbeiten';
			this.showModal = true;

        },

        eventDelete(event) {

            var self = this;

			this.entityDelete('calendarEntry', event.id, 'CALENDAR-EVENT-DELETE-CONFIRMATION')
				.then(function(response) { self.fetchData(); });

        },


        eventSave() {

            // validate must have fields
			if(typeof this.activeEvent.id == 'undefined' && this.activeEvent.type == null) {
		   		this.$notify.open({ content: 'Bitte wählen Sie einen Typ!', type: 'warning' });
			   	return;
		   	}
			else if(this.activeEvent.title == null || this.activeEvent.title == "") {
				this.$notify.open({ content: 'Bitte geben Sie einen Titel ein!', type: 'warning' });
				return;
			}
			else if(this.activeEvent.startDate == null || this.activeEvent.startDate == "") {
				this.$notify.open({ content: 'Bitte geben Sie ein Startdatum ein!', type: 'warning' });
				return;
			}
			else if(this.activeEvent.endDate == null || this.activeEvent.endDate == "") {
				this.$notify.open({ content: 'Bitte geben Sie ein Enddatum ein!', type: 'warning' });
				return;
			}

			// format START and END date
			var startDate = new Date(this.activeEvent.startDate);
			startDate.setHours(0);
			startDate.setMinutes(0 - startDate.getTimezoneOffset());

			var endDate = new Date(this.activeEvent.endDate);
			endDate.setHours(23);
			endDate.setMinutes(59);
			endDate.setSeconds(59);

			this.activeEvent.startDate = startDate.toISOString();
			this.activeEvent.endDate = endDate.toISOString();
			this.activeEvent.site = null;
			this.activeEvent.marketingChannel = null;

            var self = this;

			this.entityCreateOrUpdate('calendarEntry', this.activeEvent)
				.then(function(response) {
					self.closeModal();
					self.fetchData();
				});

        },


        calculateColWidth(month) {

			let width = (this.currentColsWidth / this.currentDaysPerYear * this.daysInMonth(month-1, this.currentYear) ) * 100 / this.currentColsWidth;
			return "width: "+width+"%";
		},

        getImage(image, thumb=false) {

			if(image == null) {
				return '';
			}

            return this.$config.assets + image;

		},

        log(article) {

        },

        goToMonth(n) {

            this.calendarView = 'month';
            this.currentMonth = (n-1);

        },

        goToArticle(article) {

            this.$router.push({ name: 'complatContentPoolContent', params: { 'contentID': article.id }});

        },


        goToVariant(variant, articleId) {

            this.$router.push({ name: 'complatContentPoolContent', params: { 'contentID': articleId, 'tab': variant.type }});

        },

        resetFilters() {

			this.filterArticleTopic = null;
			this.filterArticleCategory = null;
			this.filterArticleVariant = null;
			this.filterArticleStatus = null;

		},


        fetchData() {

            this.isLoading = true;
            this.resData = null;

            var self = this;


            function getArticles() {

                var url = "";

                if(self.articleId != null) {

                    url = self.calendarView == 'month'
                        ? 'article/calendarList?article='+self.articleId+'&year='+self.currentYear
                        : 'article/calendarList?article='+self.articleId+'&year='+self.currentYear+'&month='+(self.currentMonth+1)

                } else {

                    url = self.calendarView == 'month'
                        ? 'article/calendarList?year='+self.currentYear+'&month='+(self.currentMonth+1)
                        : 'article/calendarList?year='+self.currentYear

                }


                return self.axios.get(self.$config.api + url);

            }

            function getCommonEvents() {

                let url = self.calendarView == 'month'
                    ? 'calendarEntry/month?month='+(self.currentMonth+1)+'&year='+self.currentYear+'&format=tree&filters[marketingChannel]=NULL&filters[showInCommunicationPlatform]=1'
                    : 'calendarEntry/year?year='+self.currentYear+'&format=tree&filters[marketingChannel]=NULL&filters[showInCommunicationPlatform]=1'


                return self.axios.get(self.$config.api + url);

            }

            this.axios.all([getArticles(), getCommonEvents()])
                .then(self.axios.spread(function (resArticles, resCommonEvents) {

                    self.articleTopics = resArticles.data.articleTopics;
                    self.articleCategories = resArticles.data.articleCategories;
                    self.articleVariantTypes = resArticles.data.articleVariantTypes;

                    self.resData = resArticles.data.articles;
                    self.commonEvents = resCommonEvents.data;

                    self.isLoading = false;

                })).catch(function(error) {
                    console.log("ERROR: ", error);
                });

        },


		isDateHoliday(year, month, day) {

			var selectedDate = new Date(year, month, day);

			// if day is saturday or sunday
			if([0,6].indexOf(selectedDate.getDay()) > -1) {
				return true;
			}

			// check for fixed holiday days
			let dateStr = month+1 + '-' + day;
			if(['1-1', '1-6', '5-1', '8-15', '10-26', '11-1', '12-8', '12-24', '12-25', '12-26', '12-31'].indexOf(dateStr) > -1) {
				return true;
			}

			// variable holidays
			var holidays = [
				Number(this.addDays(this.getEasterDate, 1)),	// ostermontag
				Number(this.addDays(this.getEasterDate, 39)),	// christi himmelfahrt
				Number(this.addDays(this.getEasterDate, 50)),	// pfingsmontag
				Number(this.addDays(this.getEasterDate, 60))	// fronleichnam
			];

			if(holidays.indexOf(Number(selectedDate)) > -1) {
				return true;
			}

			return false;

		},

		addDays(date, days) {
			var result = new Date(date);
			result.setDate(result.getDate() + days);
			return result;
		},


		isCurrentDay(year, month, day) {

            month = month + 1;
			var myDate = new Date(year, month, day);
			myDate = myDate.getFullYear()+'-'+myDate.getMonth()+'-'+myDate.getDate();

			var cDate = new Date();
			cDate = cDate.getFullYear()+'-'+cDate.getMonth()+'-'+cDate.getDate();

			return cDate == myDate;

		},



        getMarkerPosition(type) {

            let marginLeft = type=='year'
				? this._calculateOffset(this.date) + 4
            	: this.currentColWidth * this.date.getDate() - (this.currentColWidth /2);

			return 'left: ' + (200 + marginLeft) + 'px';

        },

        daysInMonth(m, y) { // m is 0 indexed: 0-11

            switch (m) {
                case 1 :
                    return (y % 4 == 0 && y % 100) || y % 400 == 0 ? 29 : 28;
                case 8 : case 3 : case 5 : case 10 :
                    return 30;
                default :
                    return 31
            }

        },

        nav(next=false) {

            if(this.calendarView == 'month') {

                if(next == true) {

                    if(this.currentMonth == 11) {
                        this.currentMonth = 0;
                        this.currentYear += 1;
                    } else {
                        this.currentMonth += 1;
                    }

                } else {

                    if(this.currentMonth == 0) {
                        this.currentMonth = 11;
                        this.currentYear -= 1;
                    } else {
                        this.currentMonth -= 1;
                    }

                }

            } else {

                this.currentYear = (next == true) ? this.currentYear + 1 : this.currentYear -1;

            }

            // get new col width
            // this.getColWidth();

            // fetch new data
            this.fetchData();

        },

        changeCalendarView(type) {

            this.calendarView = type;
            this.fetchData();

        },

        getEventPosition(publication, type="") {

            // "SPECIAL EVENTS"
            if(type == 'commonEvent') {

                let bgColor = publication.type.data.color;
    			return 'top: 8px; bottom: 8px; left: ' + this._calculateOffset(publication.startDisplayDate) + 1 + 'px; width: ' + ( this._getDaysBetween(publication.startDisplayDate, publication.endDisplayDate) -1 ) + 'px; background-color:'+bgColor;

            }

            // COMMON EVENTS
            else {

                let bgColor = '';
                let marginTop = '2';

                switch(type) {
                    case 'HERBA_IMPULSE_PRINT': marginTop = '1'; break;
                    case 'HERBA_IMPULSE_ONLINE': marginTop = '15'; break;
                    case 'NEWSLETTER': marginTop = '29'; break;
                    case 'FACEBOOK': marginTop = '43'; break;
                    case 'INTRANET': marginTop = '57'; break;
                    case 'COOPERATE': marginTop = '71'; break;
                    case 'TEASER_INTERNAL': marginTop = '85'; break;
                }


                let publishDate = publication.publishDate;

                // note: the +1 and/or -1 reflect the border within the columns
                // they make sure that the event nicely fits in a column
                if(this.calendarView == 'month') {

                    // the value of -9:
                        // -7 == half of the icon width
                        // -2 == 2* 1px border
                    var marginLeft = this._calculateOffset(publishDate) + ((this.currentColWidth/2) - 9);

                } else {

                    var marginLeft = this._calculateOffset(publishDate) - 8;

                }

                return 'top: '+marginTop+'px !important; bottom: auto; left: '+marginLeft+'px; width: 14px;';

            }

        },


        _calculateOffset(date) {

			let millisecondsPerDay = 86400000; // 24 * 60 * 60 * 1000;

			if(this.calendarView == 'year') {

				return (((this._treatAsUTC(date) - this._treatAsUTC(this.currentYear + '-1-1')) / millisecondsPerDay * this.currentColsWidth ) / this.currentDaysPerYear);

			} else {

				return (this._treatAsUTC(date) - this._treatAsUTC(this.currentYear + '-' + (this.currentMonth + 1) + '-1')) / millisecondsPerDay * this.currentColWidth;

			}

        },

		_getDaysBetween(startDate, endDate) {

            let millisecondsPerDay = 86400000; // 24 * 60 * 60 * 1000;
			let timespan = (this._formatEndDate(endDate) - this._treatAsUTC(startDate)) / millisecondsPerDay;

            if(this.calendarView == 'year') {

                return Math.round(timespan) * this.currentColsWidth / this.currentDaysPerYear;

            } else {

                return timespan * this.currentColWidth;

            }

        },

        _treatAsUTC(date) {

			var d = new Date(date);
		 	// d.setMinutes(d.getMinutes() - d.getTimezoneOffset());

			d.setMinutes(0);
            d.setHours(0);
			return d;

		},

		_formatStartDate(date) {
			return this._treatAsUTC(date);
		},

		_formatEndDate(date) {

			let d = new Date(date);
			d.setHours(23);
			d.setMinutes(59);
			d.setSeconds(59);

			return d;

		},

    }

}
</script>


<style scoped>

    /* CALENDAR
    -----------------------------------------------------------------------*/
    .calendar {
        position: relative;
        z-index: 0;
        width: 100%;
        min-width: 800px;
    }

    .calendar ul.calendarHeader {
        position: relative;
        width: 100%;
        min-height: 50px;
        margin: 0 0 15px 0 !important;
        /*padding: 0 0 0 150px !important;*/
        padding: 0 0 0 200px !important;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        border-bottom: none !important;
    }
    .calendar ul.calendarHeader::before {
        content:"D";
        margin: 1px auto 1px 1px;
        visibility: hidden;
        padding: 5px;
    }
    .calendar ul.calendarHeader > li {
        display: flex;
        margin: 1px;
        padding: 5px;
    }
    .calendar ul.calendarHeader > li:last-child {
        margin-left: auto;
    }
    .calendar ul.calendarHeader > li:last-child button.is-active {
        background-color: #ddd;
    }


    .calendar ul.calendarHeader > li.navigation {
        display: flex;
        align-items: center;
    }
    .calendar ul.calendarHeader > li.navigation .prev,
    .calendar ul.calendarHeader > li.navigation .next {
        cursor: pointer;
        color: #aaa;
        transition: color .3s ease;
    }
    .calendar ul.calendarHeader > li.navigation .prev:hover,
    .calendar ul.calendarHeader > li.navigation .next:hover {
        cursor: pointer;
        color: #000;
    }
    .calendar ul.calendarHeader > li.navigation .title {
        font-size: 18px;
        text-transform: uppercase;
        margin: 0;
    }


    .calendar .calendarBody {
        position: relative;
        /*overflow: hidden;*/
        padding-top: 30px;
    }
    .calendarBody .currentDayMarker {
        position: absolute;
        z-index: 99;
        height: auto;
        top: 22px;
        bottom: -8px;
        border-right: 1px solid #666;
        margin-right: -1px;
    }



    /* ROWS
    -----------------------------------------------------------------------*/
    .rows {
        position: relative;
        z-index: 2;
        width: 100%;
        overflow: hidden;
    }
    .rows .row {
        position: relative;
        width: 100%;
        min-height: 100px;
        margin: 0;
        padding: 8px 0;
        display: flex;
        align-items: center;
        transition: background .2s ease;
    }

    /* set a bottom margin on the last row */
    .rows .row:last-child {
        /*margin-bottom: 15px;*/
    }

	.rows .row > .label {
        min-width: 150px;
        width: 200px;
        text-align: left;
        font-weight: normal;
        margin: 0;
        padding: 0 5px 0 0;
        font-size: 11px;

        display: flex;
        align-items: center;
    }

    .rows .row > .label .imgWrapper {
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size: cover;
        width: 85px;
        height: 60px;
        margin: 0;
        background-color: #FFF;
        border: 1px solid #efefef;
        border-radius: 2px;
    }
    .rows .row > .label .imgWrapper[lazy=loading]  {
        background-size: 30% !important;
    }
    .rows .row > .label .imgWrapper[lazy=error]  {
        background-image: none !important;
    }
    .rows .row > .label .title {
        font-size: 11px;
        max-width: 110px;
        padding: 0 0 0 5px;
    }



    .rows .row .events {
        position: absolute;
        left: 200px;
        right: 0;
        top: 0;
        bottom: 0;
    }
    .rows .row .events .event {
        /*
        position: absolute;
		z-index: 1;
        font-size: 10px;
        cursor: pointer;
        height: 12px;
        */

        position: absolute;
        z-index: 1;
        /*
        top: 8px !important;
        bottom: 8px !important;
        */
        left: 0;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        font-size: 10px;
        text-align: center;
        color: #fff;
        overflow: hidden;
        border-radius: 2px;
        cursor: pointer;
    }
    .rows .row .events .event .eventTitle {
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        width: auto;
        position: absolute;
        left: 0;
        right: 0;
        top: 2px;
        bottom: 2px;
        padding: 0 10px;

        white-space: nowrap
    }

	.rows .row.category {
		background: #FFF;
		margin: 20px 0 10px 0;
	}
	.rows .row.category .label .icon {
		margin-left: 5px;
	}

	.rows .row:not(.category):nth-child(odd) {
		background-color: rgba(226,230,233,0.4);
	}


    /* SPECIAL EVENTS ROWS
    -----------------------------------------------------------------------*/
    .rows.specialEvents .row  {
        min-height: 15px;
        display: flex;
	    align-items: center;
    }
    .rows.specialEvents .row.category .label {
        font-weight: bold;
        font-size: 13px;
		display: flex;
		justify-content: flex-end;
	    align-items: center;
        padding-right: 15px;
    }
    .rows.specialEvents .row > .label {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        text-align: right;
        padding-right: 15px;
    }
    .rows.specialEvents .row .event {
        position: absolute;
        z-index: 1;
        margin: auto;

        /*
        top: 0;
        bottom: 0;
        min-width: 20px;
        min-height: 20px;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        text-align: center;
        color: #fff;
        overflow: hidden;
        border-radius: 100px;
        cursor: pointer;
        */

        min-width: 1px;
        top: 8px !important;
        bottom: 8px !important;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        text-align: center;
        color: #fff;
        overflow: hidden;
        border-radius: 2px;
        cursor: pointer;
    }

    /* COLS
    -----------------------------------------------------------------------*/
    .cols {
        display: -webkit-box;      /* OLD - iOS 6-, Safari 3.1-6 */
        display: -moz-box;         /* OLD - Firefox 19- (buggy but mostly works) */
        display: -ms-flexbox;      /* TWEENER - IE 10 */
        display: -webkit-flex;     /* NEW - Chrome */
        display:flex;

        /*
        flex-wrap: nowrap;
        justify-content: space-around;
        align-items: stretch;
        */

        -webkit-justify-content: space-around;
        justify-content: space-around;

        -webkit-flex-flow: row nowrap;
        flex-flow: row nowrap;
        -webkit-align-items: stretch;
        align-items: stretch;


        position: absolute;
        z-index: 0;
        left: 200px;
        top: 0;
        bottom: 0;
        right: 0;
    }
    .cols .col {
        min-width: 20px;
        position: relative;
    }
	.cols .col.day {
        flex-grow: 1;
		flex-basis: 0;
        min-width: 20px;
        position: relative;
	}
    .cols .col .head {
        text-align: center;
        font-size: 11px;
        color: #888;
        padding: 0;
    }
    .cols .col .body {
        position: absolute;
        top: 30px;
        bottom: 0;
        left: 0;
        right: 0;
        width: auto;
        border-right: 1px solid #e2e6e9;
    }
    .cols .col:first-child .body {
        border-left: 1px solid #e2e6e9;
    }
    .cols .col .body.isWeekend {
        background: #f6f7fb !important;
    }


    /*
    POPOVER
    -----------------------------------------------------------------------*/
	.popover-content .calendarPopover {
		font-size: 11px;
	}
	.popover-content .calendarPopover .block {
		padding: 8px 14px !important;
		margin: 0 -8px;
		border-bottom: 1px solid #ddd;
		margin-bottom: 2px;
	}
	.popover-content .calendarPopover .block:last-child {
		border-bottom: none !important;
	}
	.popover-content .calendarPopover .block .edit .icon.is-small {
		font-size: 12px;
	    height: 14px;
	    line-height: 14px;
	    width: 14px;
		transition: color .3s ease;
		color: #aaa;
	}
	.popover-content .calendarPopover .block .edit .icon.is-small:hover {
		color: #222;
	}


	.popover-content .calendarPopover .channel {
		text-transform: uppercase;
		font-size: 9px;
		color: #aaa;
		display: block;
		margin-bottom: 2px;
	}
	.popover-content .calendarPopover .title {
		font-size: 11px;
		font-weight: bold;
		display: block;
		line-height: 1.1rem;
	}
    .popover-content .calendarPopover .status {
        font-size: 11px;
	}

    .popover-content .calendarPopover .newsletterChannel > span:first-child,
    .popover-content .calendarPopover .date > span:first-child,
    .popover-content .calendarPopover .status > span:first-child {
        display: inline-block;
        width: 100px;
	}



    .event .icon {
        color: #aaa;
        transition: color .3s ease;
    }
    .event .icon:hover {
        color: #000;
    }
    .event .icon.isReady {
        color: #45A3D2;
    }
    .event .icon.isReady:hover {
        color: #3E5D78;
    }



    /* EMBEDDED view
    -----------------------------------------------------------------------*/
    .embeddedView .rows .row > .label {
        min-width: 150px;
        width: 200px;
        text-align: right !important;
        font-weight: normal;
        margin: 0;
        padding: 0 15px 0 0;
        font-size: 11px;
        display: block;
    }

</style>
